import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { CreateInfrastructureRequest, InfrastructureDto, InfrastructureService, InfrastructureType, ParkingSpaceDto } from '../../../../api/gen';
import { CommonModule } from '@angular/common';
import { JJamesCardComponent } from 'shared-lib';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-create-infrastructure-parking-space',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    JJamesCardComponent,
    MatSnackBarModule
  ],
  templateUrl: './create-infrastructure-parking-space.component.html',
  styleUrl: './create-infrastructure-parking-space.component.scss'
})
export class CreateInfrastructureParkingSpaceComponent {
  @Input({ required: true }) parkingSpace!: ParkingSpaceDto;
  @Output() infrastructureCreated = new EventEmitter<InfrastructureDto>();
  @Output() skip = new EventEmitter<void>();

  form: FormGroup;
  isSaving = signal(false);

  constructor(
    private fb: FormBuilder,
    private infrastructureService: InfrastructureService,
    private snackBar: MatSnackBar
  ) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      description: [''],
    });
  }

  async onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isSaving.set(true);
    const formValue = this.form.value;

    const request = {
      name: formValue.name,
      description: formValue.description,
      infrastructureType: InfrastructureType.ParkingSpace,
      parkingSpaceId: this.parkingSpace.id,
    };

    try {
      const newInfrastructure = await firstValueFrom(this.infrastructureService.infrastructuresPost(request as any));
      this.snackBar.open('Infrastructure created successfully.', 'Close', { duration: 3000 });
      this.infrastructureCreated.emit(newInfrastructure as InfrastructureDto);
    } catch (error) {
      console.error('Error creating infrastructure:', error);
      this.snackBar.open('Failed to create infrastructure. Please try again.', 'Close', { duration: 5000 });
    } finally {
      this.isSaving.set(false);
    }
  }

  onSkip() {
    this.skip.emit();
  }
}
